<template>
  <v-container fluid>
    <a name='etc'></a>
    <v-container>
      <div class='item'>
        当日の入場時間は13:30~14:30までとさせていただいております。<br />
        遅れないようお願いいたします。
      </div>
      <div class='item'>
        LT発表中は食事などはご遠慮いただいております。
      </div>
      <div class='item'>
        登壇者や、参加者の写真撮影等はご遠慮ください。
      </div>
      <div class='item'>
        緊急連絡先<br />
        Mail: sugaohonda@gmail.com<br />
        Discord : スガオ#7145<br />
      </div>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'eventother',
  props: {}
}
</script>

<style scoped>
  .item {
    margin-left: 1rem;
    position: relative;
  }

  .item:before {
    content: '';
    width: 0.25rem;
    height: 0.25rem;
    background-color: rgb(52, 52, 52);
    border-radius: 50%;
    position: absolute;
    top: 0.5rem;
    left: -1rem;
  }

  .item:not(:first-of-type) {
    margin-top: 0.5rem;
  }
</style>
